import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/deadBirds_bg.mp4'
import _imports_1 from '../assets/icon_twitter.png'
import _imports_2 from '../assets/icon_discord.png'
import _imports_3 from '../assets/icon_opensea.png'


const _hoisted_1 = {
  id: "minting-dapp",
  class: "preview"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("video", {
  class: "videoBg",
  autoplay: "",
  muted: "",
  loop: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  }),
  /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_4 = { class: "small" }
const _hoisted_5 = {
  key: 1,
  class: "alert alert-warning alert-dismissible fade show",
  role: "alert"
}
const _hoisted_6 = {
  key: 2,
  class: "containerMintStatus"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Collection is "),
  /*#__PURE__*/_createElementVNode("strong", null, "sold out"),
  /*#__PURE__*/_createTextVNode("!")
], -1)
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 3,
  class: "collection-not-ready"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "spinner",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_12 = {
  key: 4,
  class: "no-wallet"
}
const _hoisted_13 = {
  key: 5,
  class: "walletTop"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"socialLinks\"><ul><li><a href=\"https://twitter.com/deadbirdNFT\" target=\"_blank\"><img src=\"" + _imports_1 + "\" alt=\"DeadBirds twitter\"></a></li><li><a href=\"https://discord.gg/boxbies\" target=\"_blank\"><img src=\"" + _imports_2 + "\" alt=\"DeadBirds discord\"></a></li><li><a href=\"https://opensea.io/collection/deadbirdsofficial/\" target=\"_blank\"><img src=\"" + _imports_3 + "\" alt=\"DeadBirds opensea\"></a></li></ul></div>", 1)

import { watch, ref } from 'vue'
import CollectionStatus from '@/components/CollectionStatus.vue'
import MintWidget from '@/components/MintWidget.vue'
import { useWeb3 } from '@/store/Web3'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const Web3 = useWeb3()
const merkleProofManualAddress = ref('')
watch(() => Web3.userAddress, (userAddress) => {
  if (!merkleProofManualAddress.value && userAddress) {
    merkleProofManualAddress.value = userAddress?.toString()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(Web3).isNotMainnet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode(" You are not connected to Polygon Mainnet. "),
          _createElementVNode("span", _hoisted_4, [
            _createTextVNode("Current network: "),
            _createElementVNode("strong", null, _toDisplayString(_unref(Web3).network?.name), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(Web3).errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_unref(Web3).errorMessage) + " ", 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(Web3).setError())),
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "alert",
            "aria-label": "Close"
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(Web3).isWalletConnected && _unref(Web3).isContractReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(CollectionStatus),
          (!_unref(Web3).isSoldOut)
            ? (_openBlock(), _createBlock(MintWidget, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" You can buy from our beloved holders on "),
                _createElementVNode("a", {
                  href: _unref(Web3).generateMarketplaceUrl,
                  target: "_blank"
                }, _toDisplayString(_unref(Web3).marketPlaceName), 9, _hoisted_9),
                _createTextVNode(". ")
              ]))
        ]))
      : _createCommentVNode("", true),
    (!_unref(Web3).isContractReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(" Loading collection data... ")
        ]))
      : (!_unref(Web3).isWalletConnected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "connectButton",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(Web3).connectWallet && _unref(Web3).connectWallet(...args)))
            }, "Connect Wallet")
          ]))
        : (_unref(Web3).isWalletConnected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "connectButton",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(Web3).connectWallet && _unref(Web3).connectWallet(...args)))
              })
            ]))
          : _createCommentVNode("", true),
    _hoisted_14
  ]))
}
}

})